import { Grid } from '@material-ui/core'
import React, { useState } from 'react'
import Lottie from 'react-lottie'
import { useEffectOnce } from 'react-use'
import { LOTTIES } from '~/common/constants'
import { containerStyle } from './error-403.style'

export const Error403 = ({ delay }) => {
	const [show, setShow] = useState(false)
	useEffectOnce(() => {
		setTimeout(() => {
			setShow(true)
		}, [delay])
	})

	if (!show) {
		return null
	}

	return (
		<Grid container justify="center" alignItems="center" css={containerStyle}>
			<Lottie
				width="100%"
				height="auto"
				options={{
					path: LOTTIES.permission_error,
					loop: true,
					autoplay: true,
					rendererSettings: {
						preserveAspectRatio: 'xMidYMid slice',
					},
				}}
			/>
		</Grid>
	)
}

Error403.defaultProps = {
	delay: 500,
}
